import { FormControl, Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CustomizedSelect from 'components/common/CustomizedSelect';
import userActions from 'components/TechnicalView/actions';
import CentralAZLocationFilter from 'components/TechnicalView/CentralAZLocationFilter';

const years = [
    {
        label: 2022,
        value: 2022,
    },
    {
        label: 2023,
        value: 2023,
    },
    {
        label: 2024,
        value: 2024,
    },
    {
        label: 2025,
        value: 2025,
    },
    {
        label: 2026,
        value: 2026,
    }
]

const scenarios = [
    {
        label: 'Drought contingency plan stages',
        value: 'drought-contingency-plans'
    },
    {
        label: 'More severe',
        value: 'more-server'
    }
]

const RightDrawer = ({ onClose }) => {
    const [scenarioValue, onChangeScenarioValue] = useState('drought-contingency-plans');
    const history = useHistory();
    const {
        setSelectedIrrigationDistrict,
        setSelectedCity, 
        loadCityMetrics, 
        loadCityWaterSources, 
        setSelectedTribe, 
        loadEntityEntitlements, 
        loadTribeMetrics, 
        setIsTribe, 
        setEntitlementYear,
        loadEntitlementsByYear,
        loadAccessDifferenceRange,
        setIsWesternEntity,
        setSelectedWesternArizonaEntity
    } = userActions();
    const { cities, tribes, western_arizona_entities, 
        irrigation_districts, entitlement_year, chart, central_az_tab,
        city_selected, is_city, is_tribe, tribe_selected, 
        western_arizona_selected, irrigation_district_selected, scenario_selected } = useSelector(
        (state) => state.technical_view
    );

    const handleChange = (value, label) => {
        let allValues = cities.concat(tribes).concat(western_arizona_entities)
        if (chart === "central_az_water_use") {
            // pie chart
            if (central_az_tab === "irrigation_district" && Object.keys(irrigation_districts).length > 0) {
                let entityValue = irrigation_districts.find((district) => district?.value === value)
                setSelectedIrrigationDistrict(entityValue); // the irrigation_districts array index is 1 below the irrigation_district value
                history.push({
                    pathname: `/visualizations/doughnut`,
                    search:  "?" + new URLSearchParams({type: "irrigation_district", dropdown: entityValue?.label}).toString()
                });
            } else if (central_az_tab === "cities" && Object.keys(cities).length > 0) {
                let entity = cities.find((data) => data?.label === label)
                loadCityMetrics(entity?.value);
                setSelectedCity(entity);
                history.push({
                    pathname: `/visualizations/doughnut`,
                    search:  "?" + new URLSearchParams({type: "cities", dropdown: entity?.label}).toString()
                });
            }            
        } else if (chart === "colorado_river_access") {
            // map
            let entity = allValues.find((data) => data.label === label)
            if (entity?.entity_type === 'Central') {
                setSelectedCity(entity);
                loadCityMetrics(entity?.value);
                loadCityWaterSources(entity?.value);
                setIsTribe(false);
                setIsWesternEntity(false);
                loadEntityEntitlements(entity?.value);
                history.push({
                    pathname: `/visualizations/map`,
                    search:  "?" + new URLSearchParams({type: "cities", dropdown: entity?.label}).toString()
                });
            } else if (entity?.entity_type === 'Tribe') {
                setSelectedTribe(entity);
                loadTribeMetrics(entity?.value);
                setIsTribe(true);
                setIsWesternEntity(false);
                loadEntityEntitlements(entity?.value);
                history.push({
                    pathname: `/visualizations/map`,
                    search:  "?" + new URLSearchParams({type: "tribe", dropdown: entity?.label}).toString()
                });
            } else {
                setSelectedWesternArizonaEntity(entity);
                setIsWesternEntity(true);
                setIsTribe(false);
                history.push({
                    pathname: `/visualizations/map`,
                    search:  "?" + new URLSearchParams({type: "irrigation_district", dropdown: entity?.label}).toString()
                });
            }
            onClose();
        } else if (chart === "water_use_versus_access") {
            // Gauge pie
            var cityFound = cities.find((item) => item.value === (value));

            loadCityMetrics(value);
            setSelectedCity(cityFound);
            loadEntityEntitlements(value);
            history.push({
                pathname: `/visualizations/gauge`,
                search:  "?" + new URLSearchParams({type: "cities", dropdown: cityFound?.label}).toString()
            });
            onClose();
        } else if (chart === "colorado_river_water_access") {
            // Area chart
            var cityFound = cities.find((item) => item.value === (value));
            loadCityMetrics(cityFound?.value);
            setSelectedCity(cityFound)
            loadEntityEntitlements(cityFound?.value);
            history.push({
                pathname: `/visualizations/area`,
                search:  "?" + new URLSearchParams({type: "cities", dropdown: cityFound?.label}).toString()
            });
            onClose();
        }
    };

    const onYearChange = (year) => {
        setEntitlementYear(year);
        loadEntitlementsByYear(year, scenario_selected?.value);
        loadAccessDifferenceRange(year);
        onClose();
    };

    return (
        <FormControl component='fieldset' style={{ width: 'calc(100vw - 90px)', maxWidth: 360, paddingLeft: 30, paddingRight: 30, marginTop: 30, paddingTop: 140 }}>
            <Grid style={{ marginBottom: 16 }}>
                <CustomizedSelect                
                    label="Scenario"
                    fullWidth={true}
                    dropdownValue={scenarioValue}
                    options={scenarios}
                    handleSelectedItem={(event) => onChangeScenarioValue(event.target.value)}
                />
            </Grid>
            <Grid style={{ marginBottom: 16 }}>
                <CustomizedSelect
                    label="Year"
                    fullWidth={true}
                    dropdownValue={entitlement_year}
                    options={years}
                    handleSelectedItem={(event) => onYearChange(event.target.value)}
                />
            </Grid>
            <Grid style={{ marginBottom: 16 }}>
                {
                    {
                        "central_az_water_use": (
                            <CentralAZLocationFilter
                                fullWidth={true}
                                label={"Location"} 
                                location_options={
                                    central_az_tab === "irrigation_district"
                                    ? irrigation_districts
                                    : cities
                                }
                                isCurrentTabCitites={central_az_tab !== "irrigation_district"}
                                handleChange={handleChange}
                                city_id={central_az_tab === 'irrigation_district' ? irrigation_district_selected?.agriculture_id : city_selected?.city_id}
                            />
                        ),
                        "water_use_versus_access": (
                            <CentralAZLocationFilter
                                fullWidth={true}
                                label={"Location"} 
                                location_options={cities}
                                handleChange={handleChange}
                                isCurrentTabCitites={true}
                                city_id={city_selected?.city_id}
                            />
                        ),
                        "colorado_river_water_access": (
                            <CentralAZLocationFilter
                                fullWidth={true}
                                label={"Location"} 
                                location_options={cities}
                                handleChange={handleChange}
                                isCurrentTabCitites={true}
                                city_id={city_selected?.city_id}
                            />
                        ),
                        "colorado_river_access": (
                            <CentralAZLocationFilter 
                                fullWidth={true} 
                                label={"Location"} 
                                location_options={cities?.concat(tribes)?.concat(western_arizona_entities)} 
                                handleChange={handleChange} 
                                city_id={is_city ? city_selected?.city_id : is_tribe ? tribe_selected?.tribe_id : western_arizona_selected?.entity_id}
                            />
                        )
                    }[chart]
                }
            </Grid>            
        </FormControl>
    )
}

export default RightDrawer;
